// Características de las invitaciones
export const FEATURES = [
  {
    id: 1,
    icon: 'https://agendalafecha.com/public/img/iconos/iconos-rsvp.svg',
    title: 'RSVP',
    description: 'Confirmacion de asistencia online'
  },
  {
    id: 2,
    icon: 'https://agendalafecha.com/public/img/iconos/iconos-mapa.svg',
    title: 'GPS',
    description: 'Indicaciones para llegar al evento con Maps'
  },
  {
    id: 3,
    icon: 'https://agendalafecha.com/public/img/iconos/iconos-regalo.svg',
    title: 'REGALOS',
    description: 'Info de tu lista de regalos, cuenta bancaria, etc'
  },
  {
    id: 4,
    icon: 'https://agendalafecha.com/public/img/iconos/iconos-galeria-fotos.svg',
    title: 'ÁLBUM DE FOTOS',
    description: 'Las fotos que marcaron tu historia'
  },
  {
    id: 6,
    icon: 'https://agendalafecha.com/public/img/iconos/iconos-canciones.svg',
    title: 'PLAYLIST',
    description: 'Sugerencias de Canciones'
  },
  {
    id: 7,
    icon: 'https://agendalafecha.com/public/img/iconos/iconos-agendar.svg',
    title: 'AGENDAR',
    description: 'Para que tus invitados agenden en su calendario'
  },
  {
    id: 8,
    icon: 'https://agendalafecha.com/public/img/iconos/iconos-musica.svg',
    title: 'MÚSICA',
    description: 'Tu canción favorita, sonando de fondo'
  },
  {
    id: 9,
    icon: 'https://agendalafecha.com/public/img/iconos/iconos-dresscode.svg',
    title: 'DRESS CODE',
    description: 'Info de vestimenta para tus invitados'
  },
  {
    id: 10,
    icon: 'https://agendalafecha.com/public/img/iconos/iconos-idioma.svg',
    title: 'MULTI IDIOMA',
    description: 'Opción de traducir a otros idiomas'
  },
  {
    id: 11,
    icon: 'https://agendalafecha.com/public/img/iconos/iconos-lista.svg',
    title: 'LISTA FICTICIA',
    description: 'Una forma original de sugerir regalos!'
  },
  {
    id: 12,
    icon: 'https://agendalafecha.com/public/img/iconos/iconos-info.svg',
    title: 'INFO ÚTIL',
    description: 'Datos sobre hospedajes, traslados, etc.'
  }
];
